import React from 'react';
import { observer } from 'mobx-react';

// Dependencies
import { FeatureFlag } from "react-launch-darkly";

// Components
import StudentEnrollment from './StudentEnrollment';
import LegacyEnrollment from './LegacyEnrollment';

const Enroll = observer(class Enroll extends React.Component {
  constructor() {
    super();
    this.renderEnrollment = this.renderEnrollment.bind(this);
    this.renderLegacyEnrollment = this.renderLegacyEnrollment.bind(this);
  }

  renderEnrollment(featureFlagValue) {
    // if(this.props.store.SessionStore.settings.smarterIdEnabled) {
    //   return <StudentEnrollment {...this.props} smarterID={true} />
    // } else {
    //   return <StudentEnrollment {...this.props} smarterID={false} />
    // }

    return <StudentEnrollment {...this.props} smarterID={false} />
  }

  renderLegacyEnrollment() {
    return <LegacyEnrollment {...this.props} />
  }

  render() {
    return (
      <FeatureFlag
        flagKey="updated-student-enrollment"
        renderFeatureCallback={this.renderEnrollment}
        renderDefaultCallback={this.renderLegacyEnrollment}
      />
    )
  }
})

export default Enroll;


// WEBPACK FOOTER //
// ./src/app/components/Enroll/Enroll.js